function disableAndWarn() {
  console.log('disable');
  $('input[name=checkout]').attr('disabled', true);
  $('.cart__minimum_order_quantity').show();
}

function enable() {
  console.log('enable');
  $('input[name=checkout]').removeAttr('disabled');
  $('.cart__minimum_order_quantity').hide();
}


function checkOrderQuantity(evt) {
  var elems = {};
  var item_count = 0;
  var elem_id;
  
  if (evt !== undefined) {
    elem_id = evt.target.id.replace('large_', '');
//     console.log('Event elem id: ' + elem_id);
    elems[elem_id] = evt.target;
  }
  
  $('.cart__qty-input').each(function (i, elem) {
    elem_id = elem.id.replace('large_', '');
    if (! elems.hasOwnProperty(elem_id)) {
//       console.log('added: ' + elem_id);
      elems[elem_id] = elem;
    } else {
//       console.log('rejected: ' + elem_id);
    }
  });

  for (var elem in elems) {
    var multiplier = 1;
    if (elems.hasOwnProperty(elem)) {
      if (typeof(elems[elem].dataset.countQuantityAs) !== "undefined") {
        multiplier = parseInt(elems[elem].dataset.countQuantityAs);
      }
      item_count += (parseInt(elems[elem].value) * multiplier);
    }
  }
  
//   console.log('item_count: ' + item_count);
  
  if (item_count !== 'undefined' && (item_count <= 0 || item_count % page_item_multiplier !== 0)) {
    disableAndWarn();
  } else {
    enable();
  }
}


$('.cart__qty-input').on('change', checkOrderQuantity);

checkOrderQuantity();